import React from 'react'
import Linkton from '@components/linkton'
import * as styles from './MessageVerification.module.scss'

/**
 * Shared presentational component for message verification error banners.
 * Renders:
 * - Email verification error banner (API code 1004)
 * - External link error banner (API code 1006)
 *
 * Used by both Conversation and CommunityMessageUser.
 */
const MessageVerificationErrors = ({
    emailVerificationError,
    externalLinkError,
    blockedError,
    verificationEmailSent,
    sendingVerificationEmail,
    handleResendVerificationEmail,
}) => {
    return (
        <>
            {emailVerificationError && (
                <div className={styles.errorContainer}>
                    <div className={styles.errorTitle}>Verify your email to send messages</div>
                    <div className={styles.errorDescription}>
                        To help keep Soundation safe from spam, you need to verify your email address before sending messages.
                    </div>
                    <div className={styles.errorActions}>
                        {verificationEmailSent ? (
                            <span className={styles.emailSentConfirmation}>Verification email sent!</span>
                        ) : (
                            <Linkton
                                className={styles.resendButton}
                                onClick={handleResendVerificationEmail}
                                disabled={sendingVerificationEmail}
                            >
                                {sendingVerificationEmail ? 'Sending...' : 'Resend verification email'}
                            </Linkton>
                        )}
                    </div>
                </div>
            )}
            {externalLinkError && (
                <div className={styles.errorContainer}>
                    <div className={styles.errorTitle}>This message contains a link we can't allow</div>
                    <div className={styles.errorDescription}>
                        To protect the community, messages can only include links from approved sites.
                    </div>
                </div>
            )}
            {blockedError && (
                <div className={styles.errorContainer}>
                    <div className={styles.errorTitle}>You can't message this user</div>
                    <div className={styles.errorDescription}>
                        This user is not accepting messages from you.
                    </div>
                </div>
            )}
        </>
    )
}

export default MessageVerificationErrors
